var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _g2, _path16, _path17, _path18, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawAddFriendsRe3Xte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 810.57201,
    height: 710.713,
    viewBox: "0 0 810.57201 710.713",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fbc32b64-bbdf-4dbc-bb60-a52584491975-230",
    "data-name": "Path 339",
    d: "M1005.286,263.53548h-3.9V156.5585a61.915,61.915,0,0,0-61.915-61.915H712.821a61.915,61.915,0,0,0-61.916,61.914v586.884a61.915,61.915,0,0,0,61.915,61.915H939.468a61.915,61.915,0,0,0,61.915-61.915V339.6835h3.9Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bb5c9466-73f2-44a0-9556-78839eb5ebb8-231",
    "data-name": "Path 340",
    d: "M988.759,152.4115v595.175a46.959,46.959,0,0,1-46.942,46.952h-231.3a46.966,46.966,0,0,1-46.973-46.952V152.4115a46.965,46.965,0,0,1,46.971-46.951h28.058a22.329,22.329,0,0,0,20.656,30.74H891.097a22.329,22.329,0,0,0,20.656-30.74h30.055a46.959,46.959,0,0,1,46.951,46.942Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a4c0f7b0-a249-48db-8324-425c4b242004-232",
    "data-name": "Path 45",
    d: "M828.632,390.51849a99.3,99.3,0,0,1-99.337-99.254v-.088c0-.208,0-.427.012-.635.3-54.4,44.863-98.7,99.325-98.7a99.337,99.337,0,0,1,.011,198.674h-.011Zm0-196.587a97.454,97.454,0,0,0-97.233,96.677c-.011.222-.011.4-.011.569a97.258,97.258,0,1,0,97.27-97.246h-.026Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "b3f05bc2-81da-406b-86dd-2b0d92091530-233",
    "data-name": "Path 39",
    d: "M931.353,494.95949H725.816a3.81,3.81,0,0,1-3.806-3.806V440.16951a3.811,3.811,0,0,1,3.806-3.806H931.353a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H931.353a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "b21e6212-c1f0-403c-bdef-232e508e770f-234",
    "data-name": "Path 40",
    d: "M789.38,455.00449a2.66449,2.66449,0,0,0,0,5.329H914.985a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.0022-.11712-.0019H789.38Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "ab780905-ae65-4edb-8494-502e8ec549f1-235",
    "data-name": "Path 41",
    d: "M789.38,470.99047a2.66449,2.66449,0,0,0,0,5.329H914.985a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11712-.00189H789.38Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "bcf324bf-85a9-4a34-8465-70a8e4155def-236",
    "data-name": "Path 42",
    d: "M931.353,580.21948H725.816a3.81,3.81,0,0,1-3.806-3.806v-50.984a3.811,3.811,0,0,1,3.806-3.806H931.353a3.811,3.811,0,0,1,3.806,3.806v50.985A3.811,3.811,0,0,1,931.353,580.21948Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H931.353a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "fd1e492a-db21-4dcb-b43f-b24103837e5e-237",
    "data-name": "Path 43",
    d: "M789.38,540.26049a2.66449,2.66449,0,0,0,0,5.329H914.985a2.665,2.665,0,0,0,.087-5.328H789.38Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "e10d4cc9-8111-46ce-a7fa-ade6cf037e94-238",
    "data-name": "Path 44",
    d: "M789.38,556.25053a2.66449,2.66449,0,0,0,0,5.329H914.985a2.665,2.665,0,0,0,.087-5.328H789.38Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "e6fa78bf-0588-4ac5-badf-0fd5526a4b08-239",
    "data-name": "Path 39-2",
    d: "M931.353,665.47749H725.816a3.81,3.81,0,0,1-3.806-3.806v-50.984a3.811,3.811,0,0,1,3.806-3.806H931.353a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H931.353a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "a87641aa-c143-4ef5-a11b-e1a417496101-240",
    "data-name": "Path 40-2",
    d: "M789.38,625.52148a2.66449,2.66449,0,0,0,0,5.329H914.985a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11712-.00189H789.38Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "a07223e8-f594-430f-b9d3-e015b3831fec-241",
    "data-name": "Path 41-2",
    d: "M789.38,641.50847a2.66449,2.66449,0,0,0,0,5.329H914.985a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11712-.00189H789.38Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "e005e6fa-4f2e-4ca5-bbad-52a51b7cf8f1-242",
    "data-name": "Path 1221",
    d: "M860.021,288.76651h-28.97v-28.971h-4.829v28.971h-28.97v4.828h28.97v28.971h4.829v-28.971h28.97Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3ebfbe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f8897680-c254-4e03-b64e-cafda03b28cd",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a4b49412-a00b-41e8-9df5-5be91e0af45a-243",
    "data-name": "Path 1236",
    d: "M415.138,653.07848s-23.688,25.944-27.072,85.727-4.512,66.551-4.512,66.551h84.6l15.784-40.603,18.052,40.6h80.087s9.024-124.079,0-127.463S415.138,653.07848,415.138,653.07848Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a51505d3-b438-42e2-99d6-990457d95d5b",
    "data-name": "Ellipse 232",
    cx: 333.784,
    cy: 212.706,
    r: 40.607,
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ec92e0b2-d4cb-42ed-ba19-b2a2a41a81da-244",
    "data-name": "Path 1238",
    d: "M703.901,654.21054l-62.039-112.8-36.1-58.655L648.629,463.57849l23.688,46.248s31.584,46.247,39.479,84.6,15.792,56.4,15.792,56.4Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a52caa4b-6a44-4841-9266-9cf72e124768-245",
    "data-name": "Path 1239",
    d: "M362.115,621.49449l92.495-81.215-4.507-65.424H424.159l-7.9,33.84-74.447,98.135Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e22ec3f3-58f4-4cea-9212-087bc1079083-246",
    "data-name": "Path 1240",
    d: "M481.686,367.69949s33.5,14.044,58.484-3.13c0,0,61.082,9.9,64.466,13.282s-3.384,104.9-3.384,104.9l-13.534,57.53s19.176,87.983-9.024,110.543l5.64,30.456s-125.206,9.024-174.838-21.432l9.022-30.45795,23.688-95.879-14.664-133.1S438.818,369.9555,481.686,367.69949Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa85c0f3-d286-4cf0-8f31-f3dff29d3dd6-247",
    "data-name": "Path 1241",
    d: "M575.873,382.92549l29.328-4.508s14.664,2.256,28.2,30.456,28.2,65.423,28.2,65.423l-50.759,22.56-41.735-65.423Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad0ad546-ac25-4851-b25e-0217cff5ddae-248",
    "data-name": "Path 1242",
    d: "M434.312,394.7705l-6.768,5.64s-9.024,32.712-9.024,55.271v30.456l40.608,4.512Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bca4ff40-2aaf-4255-a760-4285173e03c8-249",
    "data-name": "Path 1243",
    d: "M487.902,318.37051s-5.52-5.961-4.961-13.423a42.54637,42.54637,0,0,0-.805-12.685s1.728-12.213,4.279-19.293.4-9.543,11.366-13.408,3.985-17.841,36.314-6.7a8.844,8.844,0,0,0,9.619,1.968c5.969-2.186,9.566,6.014,9.566,6.014s3.723-3.055,5.812.121,12.193-4.062,15.9,19.041-9.014,43.706-9.014,43.706-1.785-36.97-22.781-37.641-44.74-8.623-47.685,6.945S487.902,318.37051,487.902,318.37051Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.6049,
    cy: 526.62787,
    r: 17.5,
    fill: "#ffb8b8"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "b2a9f943-63e7-459e-aa16-a074d5f617d3-250",
    "data-name": "Path 1259",
    d: "M221.159,739.46752l288.216-57.532-24.086-120.66-288.216,57.529Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "ebdb1a1e-e7bd-4f26-86a1-c9c47a08bbef-251",
    "data-name": "Path 1260",
    d: "M511.734,683.51151l-292.148,58.32-24.872-124.6,292.148-58.317Zm-289,53.6,284.284-56.747-23.303-116.733-284.283,56.749Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#e4e4e4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "aef3f6ba-7c59-4e40-b9a2-55c1c94d044e",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bad16fdd-f75b-451f-b285-d445a7208cf1-252",
    "data-name": "Path 1230",
    d: "M315.13249,701.1157l-.11825.04966c-.93994.387-1.89247.75314-2.87108,1.0737-.32888.11187-.66985.215-1.00024.31493s-.67193.20523-1.014.29844c-.55675.16034-1.12669.30195-1.69966.434-.24534.06242-.50354.11733-.751.16995l-.14867.03162c-.30708.06531-.61417.13062-.92334.18614l-.79941.13932c-.14866.03162-.29549.05261-.44035.07319a42.55765,42.55765,0,1,1,6.61167-82.4992,42.55568,42.55568,0,0,0,15.32,72.03361,42.3631,42.3631,0,0,1-12.163,7.698Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3ebfbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f6393030-236e-4765-896b-209019e80fa8-253",
    "data-name": "Path 1231",
    d: "M375.9749,679.47143a41.56742,41.56742,0,0,0,5.76608,2.36785,42.33313,42.33313,0,0,1-19.61973,10.03628l-.535.11378a42.55865,42.55865,0,1,1,4.83488-82.18264,42.47666,42.47666,0,0,0,9.55375,69.66479Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3ebfbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eef8a7e5-3026-4df7-9c38-b31908ca0085-254",
    "data-name": "Path 1232",
    d: "M449.32615,629.8235A42.55764,42.55764,0,1,1,398.84642,597.05l0,0A42.55761,42.55761,0,0,1,449.32615,629.8235Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3ebfbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3469722-1f94-4c8c-8be2-4ca7447cd0bf-255",
    "data-name": "Path 1233",
    d: "M431.50446,667.79948a28.5147,28.5147,0,0,1,.62781,5.73005,42.63867,42.63867,0,0,1-32.56739,6.9264,28.51912,28.51912,0,0,1-1.75838-5.4896c-2.0825-9.79176,1.14521-19.12838,7.423-23.35235a13.17235,13.17235,0,1,1,9.99026-2.12472C422.676,650.79229,429.422,658.00772,431.50446,667.79948Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc06a3a3-a2a4-4ca1-a154-0afe6fce79b8-256",
    "data-name": "Path 1234",
    d: "M375.97551,679.47434l.02746.12911a43.49583,43.49583,0,0,1,.48483,7.14864c-4.4085,3.09244-9.336,3.98505-14.90071,5.24111l-.535.11378a42.38821,42.38821,0,0,1-16.98777.15266,4.41187,4.41187,0,0,1-.19862-.49646,27.27843,27.27843,0,0,1-1.55877-4.9933c-2.0825-9.79176,1.14522-19.12837,7.423-23.35234a13.17034,13.17034,0,0,1-.27088-25.82033,12.71988,12.71988,0,0,1,3.06958-.27973,42.51059,42.51059,0,0,0,23.44828,42.15862Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7dd16b0-14ed-45f5-915f-9409366d1879-257",
    "data-name": "Path 1235",
    d: "M322.58544,691.56426a27.32873,27.32873,0,0,1,.526,5.15062,42.4064,42.4064,0,0,1-10.96656,5.52273c-.3291.11085-.66985.215-1.00024.31492s-.67193.20524-1.01395.29845c-.55676.16033-1.1267.30195-1.69966.434-.11725.03517-.24535.06241-.36467.08779l-.535.11377c-.30708.06532-.61417.13063-.92334.18615l-.79941.13932c-.14866.03162-.29547.05261-.44036.07319a42.18129,42.18129,0,0,1-14.82447-.245.17178.17178,0,0,1-.02454-.06734,3.29885,3.29885,0,0,1-.17406-.42912,27.27355,27.27355,0,0,1-1.55877-4.9933c-2.0825-9.79176,1.14521-19.12837,7.423-23.35234a13.17034,13.17034,0,0,1-.27088-25.82033,12.89652,12.89652,0,0,1,2.1689-.27523,42.51268,42.51268,0,0,0,24.47872,42.86051Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#fff"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "a14dec19-2029-44b7-a69f-3af98ff2b6b9-258",
    "data-name": "Path 1265",
    d: "M761.073,473.30953a14.25841,14.25841,0,0,1-.289,2.868,21.32175,21.32175,0,0,1-16.65,0,14.26348,14.26348,0,0,1-.289-2.868c0-5.006,2.549-9.237,6.06-10.651a6.587,6.587,0,1,1,5.107,0C758.524,464.07253,761.073,468.30349,761.073,473.30953Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3ebfbe"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "f5db75fe-f3f0-4b0d-a92f-db6cf5b46fdd-259",
    "data-name": "Path 1266",
    d: "M761.073,560.29652a14.25858,14.25858,0,0,1-.289,2.868,21.32175,21.32175,0,0,1-16.65,0,14.26365,14.26365,0,0,1-.289-2.868c0-5.006,2.549-9.237,6.06-10.651a6.587,6.587,0,1,1,5.107,0C758.524,551.05953,761.073,555.29048,761.073,560.29652Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3ebfbe"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "b494f491-cece-4ab7-a8b0-06febc19dd5d-260",
    "data-name": "Path 1267",
    d: "M761.073,645.55352a14.25858,14.25858,0,0,1-.289,2.868,21.32175,21.32175,0,0,1-16.65,0,14.26365,14.26365,0,0,1-.289-2.868c0-5.006,2.549-9.237,6.06-10.651a6.587,6.587,0,1,1,5.107,0C758.524,636.31652,761.073,640.54748,761.073,645.55352Z",
    transform: "translate(-194.714 -94.6435)",
    fill: "#3ebfbe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 522.1049,
    cy: 564.12787,
    r: 16,
    fill: "#ffb8b8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAddFriendsRe3Xte);
export default __webpack_public_path__ + "static/media/undraw_add_friends_re_3xte.c72e3dab78a0dd191322d903e4e97727.svg";
export { ForwardRef as ReactComponent };